// extracted by mini-css-extract-plugin
export var chevron = "_nc-3";
export var chevronRotated = "_nc-4";
export var image = "_nc-1";
export var imageContainer = "_nc-0";
export var shippingAddress = "_nc-2";